<template>
  <div class="headerFixed">
    <div class="info">
      <div class="flex">
        <p class="flex" v-if="contact.TEL"><img src="../assets/img/tel.png" alt="" width="20">{{ contact.TEL }}</p>
        <p class="flex email" v-if="contact.EMAIL">
          <img src="../assets/img/email.png" alt="" width="20">{{ contact.EMAIL }}</p>
      </div>
      <div class="flex">
        <p class="flex"><img src="../assets/img/adress.png" alt="" width="20">
          {{ LocationCity }}
          <img src="../assets/img/drop.png" alt="">
        </p>
        <span class="language">EN</span>
      </div>
    </div>
    <div class="navbar flex">
      <router-link to="/index" class="flex">
        <img src="/static/imgs/website_text_logo.png" alt="" style="height: 58px;">
        <strong>{{ websiteName }}</strong>
      </router-link>
      <div class="navList flex">
        <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" router text-color="#191E42" active-text-color="#567BFF">
          <template  v-for="(item,index) in navbar">
            <el-submenu :key="index" :index="'a'+index"  v-if="item.children">
              <template slot="title">
                <span slot="title">{{ item.title }}</span>
              </template>
              <el-menu-item
                  v-for="child in item.children"
                  :index="child.path"
                  :key="child.path">
                <span class="name">{{ child.title }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item  :key="'b'+index" :index="item.path" v-else>
              <span slot="title">{{ item.title }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
      <el-dropdown v-if="!unLogin" @command="handleCommand" style="width: 62px;">
        <el-badge class="item" :max="99" value="new" :hidden="message+systemMessage==0">
          <!-- :value="message+systemMessage" -->
          <el-avatar id="h_img" :src="headImgPath" size="medium" class="el-dropdown-link"></el-avatar>
        </el-badge>
        <el-dropdown-menu slot="dropdown" class="dropMenu">
          <template v-if="userType=='user'">
            <el-dropdown-item disabled>
              <h3 class="nick-name">{{ name }}</h3>
            </el-dropdown-item>
            <!--						<el-dropdown-item command="bindwx">绑定微信</el-dropdown-item>-->
            <el-dropdown-item command="account">个人信息</el-dropdown-item>
            <el-dropdown-item command="psychologicalCounseling">我的预约
              <el-badge :value="message" class="mark" :hidden="message===0"></el-badge>
            </el-dropdown-item>
            <el-dropdown-item command="physician">关注医师</el-dropdown-item>
            <el-dropdown-item command="communicate">私信消息
              <el-badge class="mark" :value="commUnreadMsgCount" :hidden="commUnreadMsgCount===0"/>
            </el-dropdown-item>
            <el-dropdown-item command="psyTest">心理测试</el-dropdown-item>
            <el-dropdown-item command="mineCoupon">我的优惠券</el-dropdown-item>
            <!--<el-dropdown-item command="expertCon">专家会诊</el-dropdown-item>-->
            <!--<el-dropdown-item command="expertLect">专家讲座</el-dropdown-item>-->
            <el-dropdown-item command="userMessage">系统通知
              <el-badge :value="systemMessage" class="mark" :hidden="systemMessage===0"></el-badge>
            </el-dropdown-item>
            <el-dropdown-item command="bindwx">绑定微信</el-dropdown-item>
          </template>
          <template v-if="userType=='doctor'">
            <el-dropdown-item command="homepage">个人主页</el-dropdown-item>
            <el-dropdown-item command="docAccountManger">账号管理</el-dropdown-item>
            <el-dropdown-item command="doctorMessage">系统通知
              <el-badge class="mark" :value="systemMessage" :hidden="systemMessage===0"></el-badge>
            </el-dropdown-item>
            <el-dropdown-item command="follower">我的粉丝</el-dropdown-item>
            <el-dropdown-item command="communicate2">私信消息
              <el-badge class="mark" :value="commUnreadMsgCount" :hidden="commUnreadMsgCount===0"/>
            </el-dropdown-item>
            <el-dropdown-item command="bindwx">绑定微信</el-dropdown-item>
          </template>

          <el-dropdown-item command="resetPwd">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div v-if="unLogin" class="loginRouter flex">
        <router-link to="/login">登录</router-link>
        <router-link to="/registered" class="res">注册</router-link>
      </div>
    </div>

    <!-- 绑定微信组件 -->
    <bind-wx ref="bindwx"></bind-wx>
  </div>
</template>

<script>
// import BMap from 'BMap'
import SysCons from '@/api/common'
import {avatar, badge, dropdown, dropdownItem, dropdownMenu, tooltip} from 'element-ui';
import {mapGetters, mapMutations} from 'vuex';
import {getAxios} from "../api/http";
import SysConstant from '@/api/system_constant';
import bindWx from '@/components/common/bind-wx';

export default {
  name: "headerCommon",
  data() {
    return {
      LocationCity: "深圳",
      userType: '',
      studio: '工作室',
      active: -1,
      activeIndex: '1',
      allNavBar: [
        // {title: '首页', path: '/index'},
        {title: '首页', path: '/index'},
        {
          title: '媒体品牌',
          path: '/news',
          children: [
            {title: '新闻资讯', path: '/news'},
            {title: '每日研究', path: '/study'},
            {title: '亦笙公益', path: '/publicWelfare'},
            {title: '地区资源', path: '/regionalResources'},
          ]
        },
        {
          title: '医生服务',
          path: '/recruiting',
          children: [
            {title: '医生招募', path: '/recruiting'},
            {title: '用药助手', path: '/medication'},
            {title: '专家讲座', path: '/lecture'},
            {title: '专家会议', path: '/consultation'},
          ]
        },
        /*{
          title: '线下预约',
          path: '/index2',
          children: [
            {title: '深圳', path: '/4'},
            {title: '北京', path: '/5'},
            {title: '芝加哥', path: '/6'},
            {title: '亦笙云诊所', path: '/7'},
          ]
        },*/
        {title: '马上预约', path: '/consult'},
        {title: '企业服务', path: '/index4'},
        /* {title: '我要咨询', path: '/consult'},
         {title: '心理测试', path: '/exam'},
         {title: '新闻资讯', path: '/news'},
         {title: '每日研究', path: '/study'},
         {title: '专业医生', path: '/famousDoctor'},
         {title: '专业用药', path: '/medication'},  //所有用户可见(游客、普通用户无法查看具体内容)  userType: '2',
         {title: '地区资源', path: '/regionalResources'},
         {title: '专家会议', path: '/consultation'},
         {title: '专家讲座', path: '/lecture'},
         {title: '公益科普', path: '/publicWelfare'},*/
       /* {userType: '0', title: '帮助中心', path: '/helpCenter'},
        {userType: '1', title: '帮助中心', path: '/helpCenter'},
        {userType: '2', title: '帮助中心', path: '/doctor/doctorHelp'},*/
        // {title: '帮助中心', path: '/helpCenter'},
        // {title: '服务类型', path: '/serviceType'},
      ],
      navbar: [],
      doctorsNavbar: [
        {title: '主页', path: '/'},
        {title: 'banner管理', path: '/doctor/banner'},
        {title: '文章管理', path: '/doctor/articles'},
        {title: '用户管理', path: '/doctor/patients'},
        {title: '咨询管理', path: '/doctor/medicalRecord'},
        {title: '结账单', path: '/doctor/checkOut'},
        {title: '账号管理', path: '/doctor/account'},
        {title: '预约管理', path: '/doctor/reservation'},
      ],
      unLogin: true,
      headImgPath: '',
      name: localStorage.name || '',

      countNotReadMessage: 0,

      contact: SysConstant.TOP_CONTACT,
      websiteName: SysConstant.WEBSITE_NAME,
    }
  },
  computed: {
    ...mapGetters(['message']),
    ...mapGetters(['commUnreadMsgCount']),
    ...mapGetters(['systemMessage'])
  },
  mounted() {
    // this.city()    //触发获取城市方法
    this.checkLoginStatus();
    this.headImgPath = (localStorage.headImg && localStorage.headImg != 'null') ? localStorage.headImg : '/static/default_imgs/avatar.png';
  },
  inject: ['reload'],
  methods: {
    ...mapMutations(['setMessage']),
    ...mapMutations(['setSystemMessage']),
    /*city() {    //定义获取城市方法
        const geolocation = new BMap.Geolocation();
        var _this = this
        geolocation.getCurrentPosition(function getinfo(position) {
            let city = position.address.city;             //获取城市信息
            _this.LocationCity = city
        }, function () {
            _this.LocationCity = "定位失败"
        }, {provider: 'baidu'});
    },*/
    down(index) {
      this.active = index
    },
    handleCommand(command) {
      if (command == "logout") {
        let token = localStorage.access_token || '';
        // 20210426 错误时直接clear localstorage
        this.$ajax.get(SysCons.api.logout + "?token=" + token).then((res) => {
          this.unLogin = true;
          localStorage.clear();
          this.$router.push('/login');
        }).catch(() => {
          this.unLogin = true;
          localStorage.clear();
          this.$router.push('/login');
        });
      } else if (command == "account") {
        this.active = 0;
        this.countNotRead();
        this.$router.push('/user/center')
      } else if (command == "homepage") {
        this.$router.push('/workbench/' + localStorage.account)
      } else if (command == "bindwx") {
        this.$refs['bindwx'].show();
      } else if (command == "physician") {
        this.$router.push('/user/physician')
      } else if (command == "psychologicalCounseling") {
        this.$router.push('/user/counsel')
      } else if (command == "psyTest") {
        this.$router.push('/user/psyTest')
      } else if (command == "mineCoupon") {
        this.$router.push('/user/mineCoupon')
      } else if (command == "expertCon") {
        this.$router.push('/user/expertCon')
      } else if (command == "expertLect") {
        this.$router.push('/user/expertLect')
      } else if (command == "userMessage") {
        this.$router.push('/user/message')
      } else if (command === "doctorMessage") {
        this.$router.push('/doctor/message')
      } else if (command === 'resetPwd') {
        this.$router.push('/forget')
      } else if (command === 'communicate') {
        this.$router.push('/user/communicate')
      } else if (command === 'communicate2') {
        this.$router.push('/doctor/communicateDoc')
      } else if (command === 'docAccountManger') {
        this.$router.push('/doctor/info');
      } else if (command === 'follower') {
        this.$router.push('/doctor/follower');
      }
    },
    checkLoginStatus() {
      let vm = this;
      vm.headImgPath = localStorage.headImg || '';
      vm.name = localStorage.name || '';
      // localStorage.removeItem("curUid");

      // 判断token是否有效
      if (localStorage.access_token) {
        this.$ajax.post(SysCons.api.current).then(resp => {
          if (resp.data.status === 'success') {
            this.unLogin = false;

            getAxios(SysCons.api.appoint.message)
                .then((res) => {
                  if (res.data.status == "success") {
                    vm.setMessage(res.data.data)
                  }
                });

            if (localStorage.user_type && localStorage.user_type == 2) {
              this.userType = 'doctor';
              if (localStorage.account) {
                this.doctorsNavbar[0].path = '/' + localStorage.account
              }
            } else if (localStorage.user_type == 1) {
              this.userType = 'user';
            }
            this.countNotRead();
          }
          // 菜单调整
          let userType = 0;
          if (this.userType == 'user') {
            userType = 1;
          } else if (this.userType == 'doctor') {
            userType = 2;
          }
          // 添加菜单
          this.renderMenu(userType);
        });
      } else {
        this.renderMenu(0);
      }
    },
    countNotRead() {
      let that = this;
      this.$ajax.get(SysCons.api.message.system.countNotRead)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.setSystemMessage(res.data.data)
            }
          })
    },
    renderMenu(userType) { //渲染菜单
      this.navbar.length = 0;
      this.allNavBar.forEach(nav => {
        if (!nav.userType) {
          this.navbar.push(nav);
        } else if (nav.userType == userType) {
          this.navbar.push(nav);
        }
      });
    },
  },
  components: {
    [avatar.name]: avatar,
    [dropdown.name]: dropdown,
    [dropdownMenu.name]: dropdownMenu,
    [dropdownItem.name]: dropdownItem,
    [tooltip.name]: tooltip,
    [badge.name]: badge,
    bindWx
  }
}
</script>

<style scoped lang="scss">
@import '../assets/css/head.scss';

</style>
<style lang="css">
#h_img img {
  width: 100%;
  height: 100%;
}
</style>
